module.exports = __webpack_public_path__ + "static/media/goodnest4_preview.769dfaee.jpg";